import http from './http';

// GET /api/v1/profile/:userId - get another user's full profile (admin)
export async function getUserProfileById(userId) {
  try {
    const res = await http.get(`/api/v1/profile/${userId}`);
    return { data: res.data };
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to fetch user profile');
  }
}

// GET /api/v1/profile
export async function getMyProfile() {
  try {
    const res = await http.get('/api/v1/profile');
    return { data: res.data };
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to fetch profile');
  }
}

// PUT /api/v1/profile
export async function updateMyProfile(profileData) {
  try {
    const res = await http.put('/api/v1/profile', profileData);
    return { data: res.data };
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to update profile');
  }
}

// PUT /api/v1/profile (multipart/form-data with profilePicture field)
export async function updateProfilePicture(formData) {
  try {
    const res = await http.put('/api/v1/profile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return { data: res.data };
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to update profile picture');
  }
}

// DELETE /api/v1/profile
export async function deleteProfilePicture() {
  try {
    const res = await http.delete('/api/v1/profile');
    return { data: res.data };
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to remove profile picture');
  }
}

// PUT /api/v1/profile (with currentPassword/newPassword fields)
export async function changePassword(passwordData) {
  try {
    const res = await http.put('/api/v1/profile', passwordData);
    return { data: res.data };
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to change password');
  }
}
